import { useLangPrefix } from "./langRoutes";
import MAP from "./localizedSlugs.json";

export function seoSlugFor(canonical, lang) {
  return MAP.seo[canonical]?.[lang] || canonical;
}
export function blogSlugFor(canonical, lang) {
  return MAP.blog[canonical]?.[lang] || canonical;
}
export function capSlugFor(canonical, lang) {
  return MAP.capabilities[canonical]?.[lang] || canonical;
}
export function capSegmentFor(lang) {
  return MAP.capabilitySegment[lang] || "capabilities";
}

function canonicalize(section, slug) {
  for (const [canonical, variants] of Object.entries(MAP[section])) {
    if (canonical === slug || Object.values(variants).includes(slug)) return canonical;
  }
  return null;
}
export function canonicalizeSeoSlug(slug) { return canonicalize("seo", slug); }
export function canonicalizeBlogSlug(slug) { return canonicalize("blog", slug); }
export function canonicalizeCapSlug(slug) { return canonicalize("capabilities", slug); }

export const CAP_SEGMENTS_ALL = [...new Set(["capabilities", ...Object.values(MAP.capabilitySegment)])];

/* Localized public paths for the current language prefix. */
export function usePublicPaths() {
  const lp = useLangPrefix();
  const raw = lp.slice(1);
  // Italiano canonico alla root: nessun prefisso /it/ nei link interni.
  const lang = raw === "it" ? "" : raw;
  return {
    home: lang ? `/${lang}/` : "/",
    blogIndex: lang ? `/${lang}/blog` : "/blog",
    seo: (s) => (lang ? `/${lang}/${seoSlugFor(s, lang)}` : `/${s}`),
    blog: (s) => (lang ? `/${lang}/blog/${blogSlugFor(s, lang)}` : `/blog/${s}`),
    cap: (s) => (lang ? `/${lang}/${capSegmentFor(lang)}/${capSlugFor(s, lang)}` : `/${capSegmentFor("it")}/${capSlugFor(s, "it")}`),
  };
}
